import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaTools, FaArrowLeft } from 'react-icons/fa';

const ComingSoon = () => {
  const location = useLocation();

  const pathSegments = location.pathname.split("/").filter(Boolean);
  const rawModuleName = pathSegments[pathSegments.length - 1] || "Module";

  // Format: kebab-case to Title Case
  const formattedName = rawModuleName
    .replace(/-/g, " ")       // Replace dashes with spaces
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Capitalize first letter of each word

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100 bg-light text-center">
      <div>
        <FaTools style={{color:"#3e3e3e"}} size={100} className="mb-4" />
      </div>
      <h1 className="text-dark fw-bold">{formattedName} Coming Soon</h1>
      <p className="text-muted">This feature is under development. Please check back later.</p>
      <Link to={-1} className="btn d-flex justify-content-center align-items-center  btn-outline-primary mt-3">
        <FaArrowLeft className="me-2" />
         Go Back
      </Link>
    </div>
  );
};

export default ComingSoon;
